// extracted by mini-css-extract-plugin
module.exports = {"container":"_80ad21f8ef--container--ittGf","title":"_80ad21f8ef--title--vgy_K","description":"_80ad21f8ef--description--YDvGZ","footer":"_80ad21f8ef--footer--YlCDK"};